<div class="transaction-history-container">
  <div class="transaction-header">
    <div class="title-section">
      <div class="inner-tab-title">{{ title || 'Transaction History' }}</div>
      @if (showReports) {
        <app-button
          *appHasPermission="{ resource: Resources.Reports, scope: Scopes.Export }"
          buttonVariant="accent"
          buttonType="button"
          [state]="exportButtonState"
          (buttonClick)="openExport()"
        >
          <img src="shared-assets/icons/download.png" alt="Export Icon" class="icon" />
          <span>Export</span>
        </app-button>
      }
    </div>
    <div class="filter-buttons">
      <app-button buttonVariant="filter" buttonType="button" [active]="filtersApplied" (buttonClick)="toggleFilters()">
        <img [src]="'shared-assets/icons/filter.png'" alt="Filter Icon" class="filter-icon" />
        <span>Filters</span>
        @if (filtersApplied) {
          <span class="clear-icon" (click)="onFilterReset(); $event.stopPropagation()" title="Clear filters">
            <img src="shared-assets/icons/close.png" alt="Filter Icon" class="clear-icon" />
          </span>
        }
      </app-button>

      @if (showReports) {
        <app-date-picker
          [selectedPeriod]="selectedPeriod"
          (rangeChange)="onDateRangeSelected($event)"
          (presetSelected)="onPresetPeriod($event)"
          [isDisabled]="isDisabled"
        ></app-date-picker>
      }

      <app-pill-search
        [searchText]="searchText"
        placeholder="Search"
        (searchChange)="updateSearch($event)"
        [isDisabled]="isDisabled"
      ></app-pill-search>
      <button appRefreshSpin (click)="refreshDetails()" title="Refresh">
        <mat-icon>refresh</mat-icon>
      </button>
    </div>
  </div>

  <app-transactions-table
    [transactions]="transactions"
    [initialLoading]="initialLoading"
    [isLoading]="isLoading"
    [error]="error"
    [hasMoreTransactions]="hasMoreTransactions"
    [selectedTransaction]="selectedTransaction"
    [filtersApplied]="filtersApplied"
    [searchText]="searchText"
    (transactionClick)="showTransactionDetails($event)"
    (loadMore)="loadMoreTransactions()"
    (retry)="loadTransactions()"
  ></app-transactions-table>
  @if (sidebarOpen && selectedTransaction) {
    <div class="transaction-details-aside" animate.enter="slide-in-right" animate.leave="slide-out-right">
      <app-transaction-details
        [transaction]="selectedTransaction"
        (closed)="closeTransactionDetails()"
        (transactionUpdated)="onTransactionUpdated($event)"
      >
      </app-transaction-details>
    </div>
  }
</div>
